<template>
  <v-row>
    <!-- Base by type -->
    <v-col v-if="data.base_by_type" cols="12" sm="6" md="4" xl="3">
      <v-card outlined>
        <v-card-title>
          <span class="title font-weight-light">{{ $t('contact_stats.base_orders')}}</span>
        </v-card-title>
        <v-card-text class="">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
              <tr>
                <th
                  :key="item.value"
                  v-for="item in baseHeaders"
                  class="text-center"
                >
                  {{ item }}
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                v-for="(item, index) in Object.entries(data.base_by_type)"
                :key="index"
              >
                <td>
                  {{
                    lang(
                      $store,
                      `sap/listings.global.filter.order_types.${item[0]}`,
                    )
                  }}
                </td>
                <td class="text-center">{{ item[1].done }}</td>
                <td class="text-center">{{ item[1].ordered }}</td>
                <td class="text-center">{{ item[1].declined }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-col>
    <!-- Complex by type -->
    <v-col v-if="data.complex_by_type" cols="12" sm="6" md="4" xl="3">
      <v-card outlined>
        <v-card-title>
          <span class="title font-weight-light">{{ $t('contact_stats.complex_orders')}}</span>
        </v-card-title>
        <v-card-text class="">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
              <tr>
                <th
                  :key="item.value"
                  v-for="item in baseHeaders"
                  class="text-center"
                >
                  {{ item }}
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                v-for="(item, index) in Object.entries(data.complex_by_type)"
                :key="index"
              >
                <td>
                  {{
                    lang(
                      $store,
                      `sap/listings.global.filter.order_types.${item[0]}`,
                    )
                  }}
                </td>
                <td class="text-center">{{ item[1].done }}</td>
                <td class="text-center">{{ item[1].ordered }}</td>
                <td class="text-center">{{ item[1].declined }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-col>
    <!-- Orders with additional services -->
    <v-col v-if="data.services" cols="12" sm="6" md="4" xl="3">
      <v-card outlined>
        <v-card-title>
          <span class="title font-weight-light">{{ $t('contact_stats.additional_services')}}</span>
        </v-card-title>
        <v-card-text class="">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
              <tr>
                <th class="text-center">{{ $t('contact_stats.service') }}</th>
                <th class="text-center">{{ $t('contact_stats.orders_counter') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr
                v-for="service in Object.keys(data.services)"
                :key="service"
              >
                <td>
                  {{
                    lang($store, `sap/additional_services.titles.${service}`)
                  }}
                </td>
                <td>{{ data.services[service] }}</td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-col>
    <!-- Subscriptions -->
    <v-col v-if="data.subscriptions" cols="12" sm="6" md="4" xl="3">
      <v-card outlined>
        <v-card-title>
          <span class="title font-weight-light">{{ $t('contact_stats.subs.title') }}</span>
        </v-card-title>
        <v-card-text class="">
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
              <tr>
                <th>{{ $t('contact_stats.subs.end') }}</th>
                <th class="text-center">{{ $t('contact_stats.subs.cleanings') }}</th>
                <th>{{ $t('contact_stats.subs.start') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="sub in data.subscriptions" :key="sub.id" :class="{'green lighten-4': moment(sub.end).isAfter(moment())}">
                <td>{{
                    moment(sub.end)
                      .format('DD-MM-YYYY')
                  }}
                </td>
                <td class="text-center">{{ sub.orders_base_count || 0 }}</td>
                <td>{{
                    moment(sub.start)
                      .format('DD-MM-YYYY')
                  }}
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import moment from 'moment';
import i18n from '@/i18n';

export default {
  name: 'ContactStats',
  props: {
    data: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      moment,
      baseHeaders: [
        '',
        i18n.t('table.headers.completed'),
        i18n.t('table.headers.ordered'),
        i18n.t('table.headers.cancelled'),
      ],
    };
  },
};
</script>
